import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import Routes from 'routing/Routes';

import styles from './LicenseNotification.css';

/**
 * Renders a alert for expired licenses.
 */
const LicenseExpirationNotification = React.createClass({
  propTypes: {
    /** Duration string since a license expired. (e.g. "3 months") */
    expiredSince: PropTypes.string.isRequired,
  },

  render() {
    return (
      <div className={`container-fluid ${styles.licenseNotification}`}>
        <Alert bsStyle="danger">
          <h4 style={{ marginBottom: 5 }}><strong>Graylog Enterprise License Expired</strong></h4>
          <p>
            Your license <strong>expired {this.props.expiredSince} ago</strong> and Graylog Enterprise features have been disabled.
            Go to the <LinkContainer to={Routes.pluginRoute('SYSTEM_LICENSES')}><a>License page</a></LinkContainer> for
            more information or contact your Graylog account manager.
          </p>
        </Alert>
      </div>
    );
  },
});

export default LicenseExpirationNotification;



// WEBPACK FOOTER //
// ./src/web/notifications/LicenseExpirationNotification.jsx